// Time zones help when the browser language is generic English or defaults to en-US.
const zoneCountries: Record<string, string> = {
  'Europe/London': 'GB', 'Europe/Belfast': 'GB', 'Europe/Dublin': 'IE',
  'Europe/Paris': 'FR', 'Europe/Berlin': 'DE', 'Europe/Busingen': 'DE',
  'Europe/Vienna': 'AT', 'Europe/Brussels': 'BE', 'Europe/Sofia': 'BG',
  'Asia/Nicosia': 'CY', 'Asia/Famagusta': 'CY', 'Europe/Nicosia': 'CY',
  'Europe/Prague': 'CZ', 'Europe/Copenhagen': 'DK', 'Europe/Tallinn': 'EE',
  'Europe/Madrid': 'ES', 'Atlantic/Canary': 'ES', 'Africa/Ceuta': 'ES',
  'Europe/Helsinki': 'FI', 'Europe/Athens': 'GR', 'Europe/Zagreb': 'HR',
  'Europe/Budapest': 'HU', 'Europe/Rome': 'IT', 'Europe/Vilnius': 'LT',
  'Europe/Luxembourg': 'LU', 'Europe/Riga': 'LV', 'Europe/Malta': 'MT',
  'Europe/Amsterdam': 'NL', 'Europe/Warsaw': 'PL', 'Europe/Lisbon': 'PT',
  'Atlantic/Azores': 'PT', 'Atlantic/Madeira': 'PT', 'Europe/Bucharest': 'RO',
  'Europe/Stockholm': 'SE', 'Europe/Ljubljana': 'SI', 'Europe/Bratislava': 'SK',
};
for (const zone of ['New_York', 'Detroit', 'Chicago', 'Denver', 'Phoenix', 'Los_Angeles', 'Anchorage', 'Juneau', 'Sitka', 'Metlakatla', 'Yakutat', 'Nome', 'Adak', 'Boise', 'Indiana/Indianapolis', 'Indiana/Knox', 'Indiana/Marengo', 'Indiana/Petersburg', 'Indiana/Tell_City', 'Indiana/Vevay', 'Indiana/Vincennes', 'Indiana/Winamac', 'Kentucky/Louisville', 'Kentucky/Monticello', 'North_Dakota/Beulah', 'North_Dakota/Center', 'North_Dakota/New_Salem']) zoneCountries['America/' + zone] = 'US';
zoneCountries['Pacific/Honolulu'] = 'US';
for (const zone of ['Toronto', 'Montreal', 'Vancouver', 'Edmonton', 'Winnipeg', 'Halifax', 'St_Johns', 'Regina', 'Swift_Current', 'Moncton', 'Glace_Bay', 'Goose_Bay', 'Blanc-Sablon', 'Iqaluit', 'Atikokan', 'Resolute', 'Rankin_Inlet', 'Cambridge_Bay', 'Inuvik', 'Whitehorse', 'Dawson', 'Dawson_Creek', 'Fort_Nelson', 'Creston', 'Yellowknife', 'Thunder_Bay', 'Nipigon', 'Pangnirtung', 'Rainy_River']) zoneCountries['America/' + zone] = 'CA';

export function defaultCountry(countries: {code: string}[], { saved, timeZone, languages = [] }: {
  saved?: string | null; timeZone?: string; languages?: readonly string[];
} = {}): string {
  const supported = (code?: string | null) => countries.some(c => c.code === code);
  if (saved && supported(saved)) return saved;
  const zoneCountry = timeZone?.startsWith('Australia/') ? 'AU' : zoneCountries[timeZone ?? ''];
  if (zoneCountry && supported(zoneCountry)) return zoneCountry;
  for (const language of languages) {
    try {
      const region = new Intl.Locale(language).region;
      if (region && supported(region)) return region;
    } catch { /* Ignore invalid browser locale values. */ }
  }
  return supported('GB') ? 'GB' : countries[0]?.code ?? '';
}
